/**
 * The English copy every app shows for "Suggest a change". Web wraps each string in
 * `t(KEY, SUGGESTION_COPY.x)`; mobile and desktop show it as is. `{{token}}` parts are filled
 * with `fillSuggestionCopy`, and the chat line is split around `{{chat}}` by `splitChatLine`.
 */
export const SUGGESTION_COPY = {
  entryLabel: "Suggest a change",
  title: "Suggest a change",
  chatLine: "Something not working? {{chat}}, we reply fast.",
  chatLink: "Chat with us",
  fieldLabels: ["What would you like us to change or add?", "What would make Speak better for you?", "What should we improve?"],
  hint: "Say what happens now and what you expected.",
  cancel: "Cancel",
  send: "Send",
  sentTitle: "Thanks, we've got it",
  sentBody: "Our team reviews new ideas every day. We'll email you when it's live, or tell you why if we decide not to build it.",
  suggestAnother: "Suggest another",
  done: "Done",
  limitTitle: "You can send one an hour",
  limitBody: "You can send your next one at {{time}}. Need help now? Chat with us.",
  ok: "OK",
  failed: "We couldn't send this. Check your connection and try again. Your text is kept.",
  tryAgain: "Try again",
  close: "Close",
} as const;
